"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const patientFlowGeoCountyProvider = {
    name: 'patient-flow-geo-county-provider',
    tableType: 'aff',
    grain: [],
    tableGrain: [
        '!facility',
        '!affiliated-facility',
        '!county',
        'begin_year_key',
        'end_year_key',
        'origin_provider_type',
        'origin_provider_number',
        'dest_provider_type',
        'dest_provider_number',
        'lob'
    ],
    foreignKeys: [
        'county::key',
        'facility_dim_key:facility:origin_facility_dim_key',
        'facility_dim_key:affiliated-facility:dest_facility_dim_key'
    ]
};
const patientFlowGeoCountyProviderType = {
    name: 'patient-flow-geo-county-provider-type',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!county',
        'begin_year_key',
        'end_year_key',
        'origin_provider_type',
        'dest_provider_type',
        'lob'
    ],
    foreignKeys: [
        'county::key'
    ]
};
const patientFlowGeoMSAProvider = {
    name: 'patient-flow-geo-msa-provider',
    tableType: 'aff',
    grain: [],
    tableGrain: [
        '!facility',
        '!affiliated-facility',
        '!cbsa',
        'begin_year_key',
        'end_year_key',
        'origin_provider_type',
        'origin_provider_number',
        'dest_provider_type',
        'dest_provider_number',
        'lob'
    ],
    foreignKeys: [
        'cbsa::key',
        'facility_dim_key:facility:origin_facility_dim_key',
        'facility_dim_key:affiliated-facility:dest_facility_dim_key'
    ]
};
const patientFlowGeoMSAProviderType = {
    name: 'patient-flow-geo-msa-provider-type',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!county',
        'begin_year_key',
        'end_year_key',
        'origin_provider_type',
        'dest_provider_type',
        'lob'
    ],
    foreignKeys: [
        'county::key'
    ]
};
const patientFlowProviderCondition = {
    name: 'patient-flow-provider-condition',
    tableType: 'aff',
    grain: [],
    tableGrain: [
        '!facility',
        '!affiliated-facility',
        'begin_year_key',
        'end_year_key',
        'origin_provider_type',
        'origin_provider_number',
        'origin_condition_category',
        'origin_condition_category_code',
        'dest_provider_type',
        'dest_provider_number',
        'dest_condition_category',
        'dest_condition_category_code',
        'lob'
    ],
    foreignKeys: [
        'facility_dim_key:facility:origin_facility_dim_key',
        'facility_dim_key:affiliated-facility:dest_facility_dim_key'
    ]
};
const patientFlowProvider = {
    name: 'patient-flow-provider',
    tableType: 'aff',
    grain: [],
    tableGrain: [
        '!facility',
        '!affiliated-facility',
        'begin_year_key',
        'end_year_key',
        'origin_provider_type',
        'origin_provider_number',
        'dest_provider_type',
        'dest_provider_number'
    ],
    foreignKeys: [
        'facility_dim_key:facility:origin_facility_dim_key',
        'facility_dim_key:affiliated-facility:dest_facility_dim_key'
    ]
};
exports.default = [
    patientFlowGeoCountyProvider,
    patientFlowGeoCountyProviderType,
    patientFlowGeoMSAProvider,
    patientFlowGeoMSAProviderType,
    patientFlowProviderCondition,
    patientFlowProvider
];
